function escapeAttribute(value: string): string {
  return value.replace(/&/g, "&amp;").replace(/"/g, "&quot;")
    .replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/'/g, "&#39;");
}

export function iframeEmbedCode(origin: string, publicApiKey: string, name: string): string {
  const url = `${new URL(origin).origin}/chat/${encodeURIComponent(publicApiKey)}`;
  return `<iframe
  src="${escapeAttribute(url)}"
  width="100%"
  height="700"
  frameborder="0"
  style="border: none; border-radius: 12px;"
  allow="clipboard-write"
  title="${escapeAttribute(name)}"
></iframe>`;
}
